import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import GoodGovernanace from './good-governanace';
import GoodGovernanaceDetail from './good-governanace-detail';
import GoodGovernanaceUpdate from './good-governanace-update';
import GoodGovernanaceDeleteDialog from './good-governanace-delete-dialog';

const GoodGovernanaceRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<GoodGovernanace />} />
    <Route path="new" element={<GoodGovernanaceUpdate />} />
    <Route path=":id">
      <Route index element={<GoodGovernanaceDetail />} />
      <Route path="edit" element={<GoodGovernanaceUpdate />} />
      <Route path="delete" element={<GoodGovernanaceDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default GoodGovernanaceRoutes;
